import { ca } from '@cian/analytics';

import type { ICallbackParams } from '@cian/newbuilding-flat-view-order-component';

export function trackFlatViewOrderPopupOpen() {
  ca('eventSite', {
    action: 'Click',
    category: 'Card',
    label: 'personal_tour_floatingBlock',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackFlatViewOrderSuccess(params: ICallbackParams) {
  const { date, time, phone, name } = params;

  ca('eventSite', {
    action: 'Success',
    category: 'PersonalTour',
    label: 'Submit',
    name: 'oldevent',
    page: {
      extra: {
        date,
        time,
        phone,
        name,
      },
      pageType: 'Card',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
}
